export const tag = (x) => x;
export function untag(x) {
    return x;
}
export function retag(x) {
    return tag(untag(x));
}
//# sourceMappingURL=util.js.map